import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { LoginForm } from "./LoginForm/LoginForm";

import ModalTitle from "react-bootstrap/ModalTitle";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalBody from "react-bootstrap/ModalBody";

import backgroundLeft from "./images/bg-login-left.png";
import backgroundRight from "./images/bg-login-right.png";
import "./loginModal.scss";
import { CustomModal } from "Componentes/CustomModal/CustomModal";

interface ILoginModal {
  isOpenLoginModal: boolean;
  onCloseLoginModal: () => void;
}
export const LoginModal = ({
  isOpenLoginModal,
  onCloseLoginModal
}: ILoginModal) => {
  return (
    <CustomModal
      className='login-modal'
      isOpen={isOpenLoginModal}
      onClose={onCloseLoginModal}>
      <Row className=''>
        <Col className='col-bg-left-modal d-none d-lg-block col-lg-3 p-0'>
          <img src={backgroundLeft} className='bg-login-left' alt='bg-left' />
        </Col>
        <Col className='col-login-modal col-12 col-lg-6 p-0'>
          <Container className='container-login-modal p-0'>
            <div className='pt-0 modal-header'>
              <div className='modal-title'>
                Crombie Docs necesita verificar si tienes acceso
              </div>
            </div>
            <Tabs
              defaultActiveKey='login'
              className='justify-content-center align-items-center'
              id='controlled'>
              <Tab eventKey='login' title='Iniciar Sesion'>
                <ModalBody className='login'>
                  <LoginForm typeForm='login' closeModal={onCloseLoginModal} />
                </ModalBody>
              </Tab>
              <Tab eventKey='register' title='Registro'>
                <ModalBody className='register'>
                  <LoginForm typeForm='register' />
                </ModalBody>
              </Tab>
            </Tabs>
          </Container>
        </Col>
        <Col className='col-bg-rigth-modal d-none d-lg-block col-lg-3 p-0'>
          <img
            src={backgroundRight}
            className='bg-login-right'
            alt='bg-right'
          />
        </Col>
      </Row>
    </CustomModal>
  );
};
